import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLang } from '../i18n/LangContext';
import Reveal from './Reveal';

export default function Privacy() {
  const { t } = useLang();
  const sections = t('privacy.sections');

  return (
    <main className="pt-32 pb-24 min-h-screen" data-testid="privacy-page">
      <div className="max-w-[860px] mx-auto px-6 md:px-12">
        <Link to="/" data-testid="privacy-back-link" className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.24em] uppercase text-[#A1A1AA] hover:text-[#C8102E] transition-colors">
          <ArrowLeft size={14} />
          {t('privacy.back')}
        </Link>

        <Reveal as="h1" className="mt-8 font-display text-4xl md:text-6xl tracking-tight text-[#F5F5F2]">
          {t('privacy.title')}
        </Reveal>
        <Reveal className="mt-3 font-mono text-[11px] tracking-[0.24em] uppercase text-[#A1A1AA] reveal-delay-1">
          {t('privacy.updated')}
        </Reveal>

        <div className="mt-12 privacy-prose">
          {sections.map((s, i) => (
            <Reveal key={s.h} className={`reveal-delay-${(i % 4) + 1}`}>
              <h2>{s.h}</h2>
              <p>{s.p}</p>
            </Reveal>
          ))}

          <Reveal className="reveal-delay-2 mt-12 p-6 border border-[#27272A] bg-[#101013]">
            <p className="text-[#F5F5F2]">
              <strong>ALPHA 7 Soluciones y Proyectos</strong>
              <br />
              direccion@alpha7.com.mx
            </p>
          </Reveal>
        </div>
      </div>
    </main>
  );
}
